import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";

export const SaintTravelTeaser = () => (
  <section className="py-12 sm:py-16 bg-background">
    <div className="container-px mx-auto max-w-3xl px-4 text-center">
      <h2 className="font-headings text-xl font-bold text-primary sm:text-2xl">
        Traveling to Coral Springs for treatment
      </h2>
      <p className="mt-3 text-sm text-foreground/80 leading-relaxed">
        Most of our SAINT patients come from outside South Florida. We'll help
        you plan the week — airports, hotels, and a daily schedule that works.
      </p>
      <div className="mt-6">
        <Button
          asChild
          className="bg-gradient-accent text-accent-foreground shadow-glow hover:opacity-90"
        >
          <Link to="/saint-tms-travel">
            See the travel guide
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  </section>
);
